import { boot } from 'quasar/wrappers'
// import format from 'quasar/src/utils/format.js';
// const { humanStorageSize } = format
import m from 'moment'
import { i18n } from 'boot/i18n'

export const noCaps = (a = '') => a.split(' ').map(([first = '', ...rest]) => first.toUpperCase() + rest.map(w => w.toLowerCase()).join('')).join(' ')
export const currency = a => (a / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
export const byte = val => {
  if (val < 1024) return `${val} byte`
  else if (val < 1024 ** 2) return `${(val / 1024).toFixed(1)} KB`
  else if (val < 1024 ** 3) return `${(val / 1024 ** 2).toFixed(1)} MB`
  else if (val < 1024 ** 4) return `${(val / 1024 ** 3).toFixed(1)} GB`
}

export const fullAddress = a_type => {
  if (!a_type) return ''
  const { Indirizzo, NumeroCivico, Cap, common, Fk_Comune } = a_type
  const res = []
  Indirizzo && res.push(noCaps(Indirizzo))
  NumeroCivico && res.push(NumeroCivico)
  Cap && res.push(Cap)
  Fk_Comune && common && common.Comune && res.push(noCaps(common.Comune))
  return res.join(', ')
}

export const LL = a => m(String(a)).format('LL')

export default boot(async ({ Vue }) => {
  // Vue.filter('byte', val => humanStorageSize(val))
  Vue.filter('byte', byte)
  Vue.filter('currency', currency)
  Vue.filter('omit', (obj, fields) => Object.fromEntries(Object.entries(obj).filter(([key]) => !fields.includes(key))))

  Vue.filter('fromNow', a => m(String(a)).fromNow())
  Vue.filter('calendar', a => m(String(a)).calendar(null, {
    sameDay: `[${i18n.t('calendar.today')}]`,
    nextDay: `[${i18n.t('calendar.tomorrow')}]`,
    // nextWeek: 'dddd prossimo',
    lastDay: `[${i18n.t('calendar.yesterday')}]`,
    // lastWeek: '[lo scorso] dddd',
    // sameElse: 'DD/MM/YYYY'
  }))
  Vue.filter('D', a => m(String(a)).format('dddd D'))
  Vue.filter('MY', a => m(String(a)).format('MMMM YYYY'))
  Vue.filter('My', a => m(String(a)).format('MMMM YY'))
  Vue.filter('my', a => m(String(a)).format('MMM YY'))
  // Vue.filter('ll', a => a ? m(String(a)).format('ll') : null)
  Vue.filter('lll', a => a ? m(String(a)).format('lll') : null)
  Vue.filter('LLL', a => m(String(a)).format('LLL'))
  Vue.filter('LL', LL)
  Vue.filter('L', a => m(String(a)).format('L'))
  // Vue.filter('', a => m(String(a)).format('DD.MM.YYYY'))
  Vue.filter('dmY', a => m(String(a)).format('DD MMM YYYY'))
  // Vue.filter('', a => m(String(a)).format('D/M/YY'))

  Vue.filter('letters', (a = '') => a.split(' ').map(([first = '']) => first.toUpperCase()).join(''))
  Vue.filter('no-caps', noCaps)

  Vue.filter('fullAddress', fullAddress)
})
